// extracted by extract-css-chunks-webpack-plugin
module.exports = {"testimonials":"testimonials_LbD3B relative pb-10 text-black lg_pb-0"};